import React, { useState } from 'react';
import { Tabs } from 'antd';

import NewsTab from './NewsTab';
import AssetsTab from './AssetsTab/AssetsTab';
import PresetsTab from './PresetsTab';
import CurrenciesTab from './CurrenciesTab';
import IndexFundsTab from './IndexFundsTab/IndexFundsTabSwitch';
import FXCrossTable from './FXCrossTable';
import DepositsTab from './Deposits';
import EquitiesTab from './Equities';
import SwapPointsTab from './SwapPointsTab';
import MarketHoursEditableTable from './MarketHoursEditableTable';
import GeographyMarketHoursTab from './GeographyMarketHoursTabe';
import ClientDealing from './ClientDealing';
import ETFDetailsTab from './ETFDetailsTab';
import MacroBackgroundTab from './MacroBackgroundTab';
import SimplifiedOptionDataTab from '../SimplifiedOptions/SimplifiedOptionDataTab';

const Data: React.FC = () => {
  const [activeTab, setActiveTab] = useState('assets');
  return (
    <div>
      <Tabs defaultActiveKey="assets" onChange={setActiveTab}>
        <Tabs.TabPane key="assets" tab="Assets">
          <AssetsTab active={activeTab === 'assets'} />
        </Tabs.TabPane>
        <Tabs.TabPane key="equities" tab="Equities">
          <EquitiesTab />
        </Tabs.TabPane>
        <Tabs.TabPane key="simplified_options" tab="Options Curves & Audit">
          <SimplifiedOptionDataTab />
        </Tabs.TabPane>
        <Tabs.TabPane key="etf_details" tab="ETF Details">
          <ETFDetailsTab />
          {/*<IndexFundsTab />*/}
        </Tabs.TabPane>
        <Tabs.TabPane key="market_hours" tab="Geography/Market Hours">
          <GeographyMarketHoursTab />
        </Tabs.TabPane>
        <Tabs.TabPane key="deposits" tab="Deposits">
          <DepositsTab />
        </Tabs.TabPane>
        <Tabs.TabPane key="presets" tab="Presets">
          <PresetsTab />
        </Tabs.TabPane>
        <Tabs.TabPane key="macros" tab="Macro Background">
          <MacroBackgroundTab />
        </Tabs.TabPane>
        <Tabs.TabPane key="currencies" tab="Currencies">
          <CurrenciesTab />
        </Tabs.TabPane>
        <Tabs.TabPane key="indexFunds" tab="Index Funds">
          <IndexFundsTab />
        </Tabs.TabPane>
        <Tabs.TabPane key="news" tab="News">
          <NewsTab />
        </Tabs.TabPane>
        <Tabs.TabPane key="client_money" tab="Client Dealing">
          <ClientDealing />
        </Tabs.TabPane>
        <Tabs.TabPane key="FXCross" tab="FX Cross">
          <FXCrossTable />
        </Tabs.TabPane>
        <Tabs.TabPane key="SwapPoints" tab="Swap Points">
          <SwapPointsTab />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default Data;
